import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table view.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                { id: 'Id', header: '', hidden: true }, // Hidden ID column
                                {
                                    id: 'rating', // Rating column
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Icon template for editing
                                    },
                                },
                                {
                                    id: 'Description', // Description column
                                    header: _('Descripción'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Order', // Order column
                                    header: _('Orden'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the data table
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'PartnersProviders/GetPartnersProviders'; // API URL for fetching data
        const vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data
        this.on(this.app, 'partnerProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            filter = string1; // Update filter string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=1000' + string1); // Load new data with filters
        });

        // Popup window for editing
        var popupEdit = webix.ui({
            view: 'window',
            fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar') }, // Edit label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {
                view: 'form',
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: 'text',
                                labelPosition: 'top',
                                label: _('Id'), // Localized label
                                name: 'Id', // Field name
                                hidden: true, // Hidden field
                            },
                            {
                                view: 'text',
                                labelPosition: 'top',
                                label: _('Descripción'), // Localized label
                                name: 'Description', // Field name
                                readonly: true, // Read-only field
                            },
                            {
                                view: 'text',
                                labelPosition: 'top',
                                label: _('Orden'), // Localized label
                                name: 'Order', // Field name
                                type: 'number', // Number input
                                readonly: false, // Editable field
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('editform').setValues($$('editform').getCleanValues()); // Reset form values
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if ($$('editform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersProviders/UpdatePartnersProviders', // API URL for updating
                                                {
                                                    Id: values.Id, // ID to update
                                                    Description: values.Description, // Description to update
                                                    Order: values.Order, // Order to update
                                                },
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message('Error: ' + text.AlertMessage); // Show error message
                                                        } else {
                                                            webix.message('Proveedor editado satisfactoriamente'); // Success message
                                                            grid.load(url + '?start=0&count=1000' + filter); // Reload grid data
                                                            this.getTopParentView().hide(); // Close popup
                                                            $$('editform').setValues($$('editform').getCleanValues()); // Reset form values
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Error title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind edit form to data table
        this.on(this.app, 'openEdit', (item) => {
            popupEdit.show(); // Show edit popup
        });
    }
}

// FILE DOCUMENTED
